import { DEBUG } from '../../settings'

export const SALESFORCE_ORG_ID = '00D20000000Cjsl'
export const SALESFORCE_RETURN_URL = 'https://healthxchangedevices.com'

export const getSalesforceHiddenFields = (leadSource: string) => ({
  oid: SALESFORCE_ORG_ID,
  retURL: SALESFORCE_RETURN_URL,
  lead_source: leadSource,
  ...(DEBUG ? { debug: '1', debugEmail: 'fouzia.miah@healthxchange.com' } : {}),
})
